import React, { useState } from "react";
import { toast } from "react-toastify";

const CrmBulkActionsBar = ({
  leadIds = [],
  url,
  token,
  pipelineStages = [],
  onComplete,
  onClear,
}) => {
  const [stage, setStage] = useState("");
  const [reminderDate, setReminderDate] = useState("");
  const [reminderTime, setReminderTime] = useState("");
  const [saving, setSaving] = useState(false);

  if (!leadIds.length) return null;

  const apply = async (patch) => {
    setSaving(true);
    try {
      const res = await fetch(`${url}/leads/bulk-update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ leadIds, ...patch }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Bulk update failed");
      toast.success(`Updated ${data.updated} lead(s)`);
      onComplete?.();
      onClear?.();
      setStage("");
      setReminderDate("");
      setReminderTime("");
    } catch (err) {
      toast.error(err.message || "Bulk update failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="crm-bulk-bar">
      <span>
        <strong>{leadIds.length}</strong> selected
      </span>
      <select
        value={stage}
        onChange={(e) => setStage(e.target.value)}
        className="crm-insights__select"
        aria-label="Bulk stage"
      >
        <option value="">Set stage…</option>
        {pipelineStages.map((s) => (
          <option key={`${s.key}-${s.label}`} value={s.key}>
            {s.label}
          </option>
        ))}
      </select>
      <button
        type="button"
        disabled={!stage || saving}
        onClick={() => apply({ extra: stage })}
      >
        Apply stage
      </button>
      <input
        type="date"
        value={reminderDate}
        onChange={(e) => setReminderDate(e.target.value)}
        aria-label="Reminder date"
      />
      <input
        type="time"
        value={reminderTime}
        onChange={(e) => setReminderTime(e.target.value)}
        aria-label="Reminder time"
      />
      <button
        type="button"
        disabled={!reminderDate || !reminderTime || saving}
        onClick={() =>
          apply({ remainder_date: reminderDate, remainder_time: reminderTime })
        }
      >
        Set reminder
      </button>
      <button type="button" className="crm-bulk-bar__clear" onClick={onClear}>
        Clear
      </button>
    </div>
  );
};

export default CrmBulkActionsBar;
